import React, { useState, useRef, useContext } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SignaturePad from 'react-signature-canvas'
import useAuthAxios from "../../../../useAuthAxios";
import { AuthContext } from "../../../../Auth";
import { SignDialog, NomalButton, CautionButton, GrayButton } from '../../../css/CSS.js';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import { UserInputData } from '../VisitReportFrame';
import InspectionCommonDialog from '../../InspectionCommonDialog';
import { GetConfirmDialogConfig } from '../../InspectionCreateConfigDialog.js';

export default function CustomerSignature(props) {
    const { currentState } = useContext(UserInputData);

    const [open, setOpen] = React.useState(false);
    const [dialogState, setDialogState] = React.useState({
        open: false,
        title: null,
        message: null
    });

    const canvasSize = { width: 980, height: 490 }
    const handleClickOpen = () => {
        if (props?.keyData?.canEdit) {
            setOpen(true);
            setTimeout(() => {
                sigCanvas.current.fromDataURL(imageURL, canvasSize);
            }, 200);
        }
    };

    const handleClose = (_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        setDialogState(
            GetConfirmDialogConfig("close", {
                onConfirm: handleCloseConfirm,
                onCancel: handleCloseCancel,
            })
        );
    };
    const handleCloseConfirm = () => {
        setDialogState(prev => ({ ...prev, open: false }));
        setOpen(false);
    }
    const handleCloseCancel = () => {
        setDialogState(prev => ({ ...prev, open: false }));
    }

    const [imageURL, setImageURL] = useState(null);
    const [activeSave, setActiveSave] = useState(false);
    const [activeDelete, setActiveDelete] = useState(false);
    const sigCanvas = useRef({});
    const clear = () => {
        setDialogState(
            GetConfirmDialogConfig("clear", {
                onConfirm: handleClearConfirm,
                onCancel: handleCloseCancel,
            })
        );
    }
    const handleClearConfirm = () => {
        setDialogState(prev => ({ ...prev, open: false }));
        sigCanvas.current.clear();
    }

    const { auth } = useContext(AuthContext);
    const authAxios = useAuthAxios()
    const headers = {
        "Authorization": "Bearer " + auth,
        'Content-Type': 'application/json',
    };
    const save = () => {
        setImageURL(sigCanvas.current.toDataURL("image/png"));
        setActiveSave(true)
    }

    React.useEffect(() => {
        if (activeSave === true) {
            const mergeData = JSON.parse(JSON.stringify(currentState))
            let postData = {};
            mergeData.customerSign = imageURL.replace("data:image/png;base64,", "")
            postData = mergeData

            authAxios
                .post('api/visitReport/detail/' + props.keyData.kojiCD + '/' + props.keyData.rptShubetsu +
                    '?inputType=1&reportSeqNo=' + props.keyData.rptSeq
                    , postData, headers)
                .then(response => {
                    if (response.status === 200) {
                        setOpen(false)
                        setActiveSave(false)
                        props.signClose()
                    }
                }).catch((response) => {
                    alert("保存に失敗しました。", response.body);
                    setActiveSave(false)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSave]);

    const deleteSign = () => {
        setDialogState(
            GetConfirmDialogConfig("delete", {
                onConfirm: handleDeleteConfirm,
                onCancel: handleCloseCancel,
            })
        );
    }
    const handleDeleteConfirm = () => {
        setDialogState(prev => ({ ...prev, open: false }));
        setActiveDelete(true)
        setOpen(false)
    }

    React.useEffect(() => {
        if (activeDelete === true) {
            const mergeData = JSON.parse(JSON.stringify(currentState))
            let postData = {};
            mergeData.customerSign = null
            postData = mergeData

            authAxios
                .post('api/visitReport/detail/' + props.keyData.kojiCD + '/' + props.keyData.rptShubetsu +
                    '?inputType=1&reportSeqNo=' + props.keyData.rptSeq
                    , postData, headers)
                .then(response => {
                    if (response.status === 200) {
                        setActiveDelete(false)
                        setImageURL(null)
                        setOpen(false)
                        props.signClose()
                    }
                }).catch((response) => {
                    alert("保存に失敗しました。", response.body);
                    setActiveDelete(false)
                    setOpen(false)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDelete]);


    React.useEffect(() => {
        if (!currentState?.customerSign ||
            currentState?.customerSign === "") {
            setImageURL(null)
        } else {
            setImageURL("data:image/png;base64," + currentState.customerSign)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentState]);

    return (
        <React.Fragment>
            <div>
                <InspectionCommonDialog open={dialogState?.open} dialogState={dialogState} setDialogState={setDialogState} />
                <Button variant="outlined" onClick={handleClickOpen} sx={{ minWidth: "340px" }}>
                    お客様サイン
                </Button>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="340px"
                >
                    <Grid container columns={12} columnSpacing={{ xs: 1, sm: 3, md: 3 }} sx={{ pt: 2, bgcolor: "#EEEEEE", }}>
                        <Grid item xs={11} sx={{ bgcolor: "#EEEEEE" }}>
                            <DialogTitle id="alert-dialog-title" sx={{ bgcolor: "#EEEEEE" }}>
                                {"お客様サイン"}
                            </DialogTitle>
                        </Grid >
                        <Grid item xs={1} sx={{ bgcolor: "#EEEEEE" }}>
                            <DialogActions sx={{ bgcolor: "#EEEEEE" }}>
                                <Button onClick={handleClose}><CloseIcon /></Button>
                            </DialogActions>
                        </Grid>
                    </Grid>

                    <DialogContent sx={{ bgcolor: "#EEEEEE" }}>
                        <SignDialog >
                            <SignaturePad
                                ref={sigCanvas}
                                canvasProps={canvasSize}
                                minWidth={0.5}
                                maxWidth={4.0}
                                dotSize={3.0}
                                minDistance={1.0}
                                throttle={16}
                                velocityFilterWeight={0.7}
                                clearOnResize={false}
                            />
                        </SignDialog>
                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', bgcolor: "#EEEEEE", px: 3, pb: 2, gap: 3 }}>
                        <CautionButton onClick={deleteSign} sx={{ fontSize: '1.4rem', px: 4 }}>削除</CautionButton>
                        <GrayButton onClick={clear} sx={{ fontSize: '1.4rem', px: 4 }}>クリア</GrayButton>
                        <NomalButton onClick={save} sx={{ fontSize: '1.4rem', px: 10 }}>保存</NomalButton>
                    </DialogActions>
                </Dialog>
                {imageURL ? (
                    <Grid
                        container
                        direction="column"
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            pt: 0.5
                        }}>
                        <img
                            src={imageURL}
                            alt="SalesStaff"
                            style={{
                                display: "block",
                                border: "thin solid rgba(25, 118, 210, 0.5)",
                                borderRadius: "5px",
                                padding: "5px",
                                height: "170px",
                                width: "340px"
                            }}
                            onClick={handleClickOpen}
                        />
                    </Grid>
                ) : null}
            </div>
        </React.Fragment>
    );
}
